import React, { useState, useEffect, useRef } from 'react';
import BaseText from './typography/BaseText';
import PropTypes from 'prop-types';
import { getAvatarBackgroundColor } from '../../helper/helpers';
import { AVATAR_COlORS, STATUS_COLORS } from '../../constants/enum';
import { fontSize } from 'tailwindcss/defaultTheme';
export default function Avatar({ name, avatarName, avatarStyling, avatarImage, fontSize, isSuspended = false }) {
  const [avatarTextColor, setAvatarTextColor] = useState('text-white');
  const avatarText = name ? name : '-';
  const box = useRef(0);
  useEffect(() => {
    if (isSuspended) {
      if (box.current) {
        box.current.style.backgroundColor = STATUS_COLORS.GREY;
      }
      setAvatarTextColor('text-white');
      return;
    }
    if (!avatarImage) {
      const avatarBG = getAvatarBackgroundColor(name ? avatarText : avatarName);
      box.current.style.backgroundColor = getAvatarBackgroundColor(name ? avatarText : avatarName);
      if (
        avatarBG == AVATAR_COlORS[4] ||
        avatarBG == AVATAR_COlORS[5] ||
        avatarBG == AVATAR_COlORS[6] ||
        avatarBG == AVATAR_COlORS[7]
      ) {
        setAvatarTextColor('text-gray-300');
      } else {
        setAvatarTextColor('text-white');
      }
    }
  }, [avatarName,isSuspended]);

  return (
    <div>
      {avatarImage ? (
        <img className={`${avatarStyling} rounded-full object-cover`} src={avatarImage} alt="avatarImage" />
      ) : (
        <div ref={box} className={`bg-purple-500 rounded-full flex items-center justify-center ${avatarStyling}`}>
          <BaseText
            className="uppercase"
            fontWeight="text-bold"
            title={name ? avatarText : avatarName}
            fontSize={fontSize}
            textColor={avatarTextColor}
          />
        </div>
      )}
    </div>
  );
}

Avatar.propTypes = {
  name: PropTypes.string,
  avatarName: PropTypes.string,
  avatarStyling: PropTypes.string
};

Avatar.defaultProps = {
  avatarStyling: 'w-12 h-12'
};
